import React from "react";
import styles from "./admin.module.scss";

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Small line above the title, e.g. the mosque name. */
  crumb?: React.ReactNode;
  actions?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  crumb,
  actions,
}) => (
  <>
    {crumb && <div className={styles.crumb}>{crumb}</div>}
    <div className={styles.hdr}>
      <div>
        <h1 className={styles.h1}>{title}</h1>
        {subtitle && <div className={styles.sub}>{subtitle}</div>}
      </div>
      {actions && <div className={styles.acts}>{actions}</div>}
    </div>
  </>
);

export default PageHeader;
